module.exports = __webpack_public_path__ + "static/media/code.3bb366c8.svg";